import React, { Component } from 'react';
import PanelView from '../model/PanelView.js';
import moment from 'moment';
import {clone, getMinistryName, getLeaderName, toCSV, formatDate } from '../util/Utility.js';
import { EventApprovalSection } from '../util/Components.js';
import { Glyphicon } from 'react-bootstrap';


export default class EventsWeekPanelView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillMount() {
    var object = this.state.object;
    getMinistryName(object.ministryID, this).then(function(name) {
      object.ministryName = name;
      this.setState({object: object});
    }.bind(this));
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      var object = clone(newProps.objectPass);
      getMinistryName(object.ministryID, this).then(function(name) {
        object.ministryName = name;
        this.setState({object: object});
      }.bind(this));
    }
  }

  render() {

    let approvalPermissions = this.props.permissions.approval1 || this.props.permissions.approval2 || this.props.permissions.approval3 || this.props.permissions.approval4;

    var object = this.state.object;

    return (
      <PanelView type="eventsWeek" subtype="event" delete={this.props.eventType === 0 && approvalPermissions} deleteButtonTitle="Cancel" deleteConfirmationSubtext="Canceled events are marked as 'Canceled' in the app, so that people are informed that the event is no longer taking place." contact={object.originator} setState={this.setState.bind(this)} object={object} {...this.props}>
        <center>
          <h2 style={{margin: 0}}>{object.title}</h2>
          <p className="popoverTextHeader">{this.props.eventType === 1 ? moment.unix(parseInt(object.date)).format("h:mm A") : formatDate(object.date, object.endDate)}</p>
        </center>
        <div style={{height: 7}} />
        <p>{object.description}</p>
        {(this.props.eventType === 2 || this.props.eventType === 0) && <EventApprovalSection event={object} undo={this.props.permissions} />}
        {this.props.setup && <div>
          {object.roomSetup && <p>Room setup: {toCSV(object.roomSetup)}</p>}
          {object.techSetup && <p>Tech setup: {toCSV(object.techSetup)}</p>}
          {object.setupNotes && object.setupNotes !== "" && <p>Setup notes: {object.setupNotes}</p>}
          {!object.roomSetup && !object.techSetup && !(object.setupNotes && object.setupNotes !== "") && <p>No Setup Required</p>}
        </div>}
        {object.originator && <p><Glyphicon glyph="user" /> Created By {getLeaderName(object.originator)}</p>}
        {object.ministryName && <p><Glyphicon glyph="heart" /> Hosted by the {object.ministryName}</p>}
      </PanelView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/overview/EventsWeekPanelView.js
 **/